import yup from '../../../config/yup';

export const selectValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('dataframe'),
  type: yup.string().default('select'),
  action: yup.string().default('select').required('Action is required'),
  'data-frame': yup.string().required('Data Frame is required'),
  query: yup.string().required('Query is required'),
});
